import React, {Component} from 'react';
import PropTypes from 'prop-types'
import {Modal} from 'react-bootstrap';
import ArrowButton from '../button-arrow';
import {acceptPrivacy} from '../../../actions/user';
import {connect} from "react-redux";
import {getPrivacyPolicy, loadPageContent} from "../../../actions/content";
import {checkPermission} from "../guards/can";

class PrivacyPopup extends Component {
  componentWillMount() {
    const {show, dispatch, popupActive} = this.props;
    if(show) {
      dispatch(getPrivacyPolicy());
    }
    popupActive(true);
  }

  onConfirm() {
    const {dispatch} = this.props;

    dispatch(acceptPrivacy()).then(() => {
      try {
        dispatch({type: 'TOGGLE_PRIVACY_MODAL', payLoad: false});
      } catch(error) { //
        // swallowed modal lib bug error
      }
    });
  }

  cancel(event) {
    event.preventDefault();
  }

  componentWillUnmount() {
    const { popupActive } = this.props;
    popupActive(false);
  }

  render() {
    const {content} = this.props;
    return (
      <div className="container-fluid">
        <Modal
          show={true}
          animation={false}
          container={this}
          aria-labelledby="contained-modal-title"
          backdropStyle={{width: "100%"}}
        >
          <Modal.Header>
            <Modal.Title>Our Privacy Policy has been updated</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{
              overflowY: "auto",
              maxHeight: window.innerHeight / 2
            }} dangerouslySetInnerHTML={{__html: content}}/>
          </Modal.Body>
          <Modal.Footer>
            <ArrowButton color="red"
                         className="pull-right"
                         submit={false}
                         arrow={false}
                         onClick={() => this.onConfirm(true)}>Close</ArrowButton>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

PrivacyPopup.propTypes = {
  show: PropTypes.bool
};

PrivacyPopup.defaultProps = {
  show: false,
};

export default connect(state => ({
  content: state.privacyPolicy.content
}))(PrivacyPopup);


// WEBPACK FOOTER //
// ./src/components/common/privacy-policy/privacy-popup.jsx